// Thin wrapper around Giphy's REST API (raw fetch, no SDK - the endpoints are two simple GET
// requests, not worth a whole extra dependency for). Used by the GIF widget's picker to offer a
// trending list plus live search, instead of requiring the user to paste a GIF URL by hand.
const API_BASE = 'https://api.giphy.com/v1/gifs'
const API_KEY = process.env.VUE_APP_GIPHY_API_KEY

// Giphy's response includes several pre-rendered renditions per GIF - fixed_width (a real .gif,
// a few hundred px wide) is a good balance of quality/size for both the picker thumbnail and the
// actual overlay content, with fixed_width_small used for the thumbnail when available (a bit
// lighter, so the picker grid loads faster) and falling back to fixed_width if not.
const mapResult = (item) => ({
    id: item.id,
    title: item.title || '',
    thumbnailUrl: (item.images.fixed_width_small || item.images.fixed_width).url,
    gifUrl: item.images.fixed_width.url
})

const fetchGifs = async (url) => {
    if (!API_KEY) return []
    const response = await fetch(url)
    if (!response.ok) throw new Error(`La requête Giphy a échoué (${response.status})`)
    const json = await response.json()
    return (json.data || []).map(mapResult)
}

export const fetchTrendingGifs = (limit = 24) => (
    fetchGifs(`${API_BASE}/trending?api_key=${API_KEY}&limit=${limit}&rating=g`)
)

export const searchGifs = (query, limit = 24) => {
    if (!query || !query.trim()) return fetchTrendingGifs(limit)
    return fetchGifs(`${API_BASE}/search?api_key=${API_KEY}&limit=${limit}&rating=g&q=${encodeURIComponent(query.trim())}`)
}
